import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Button,
  Label,
  FormGroup,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Card,
  CardTitle,
  CardSubtitle,
  CardText,
  Row,
  CardBody,
} from "reactstrap";
import * as FaIcons from "react-icons/fa";

const ModalRequisito = ({ isOpen, toggle }) => {
  ////
  const baseUrl = "https://bqef-bo.com/api/A/apiDash.php";
  const [lista, setLista] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);

  /////Obtener convocatoria
  const getConvocatoria = async () => {
    try {
      const res = await axios.get(`${baseUrl}?action=getConv`);
      const receivedData =
        res.data.Convocatorias && Array.isArray(res.data.Convocatorias)
          ? res.data.Convocatorias
          : [];

      // Filtrar solo los archivos de tipo 'convocatoria'
      const convocatorias = receivedData.filter(
        (item) => item.tipo_archivo === "convocatoria",
      );

      // Obtener el último archivo de convocatoria
      const ultimoConvocatoria =
        convocatorias.length > 0
          ? convocatorias[convocatorias.length - 1]
          : null;

      // console.log(ultimoConvocatoria);

      // Si quieres guardar solo el último en el estado
      setLista(ultimoConvocatoria ? [ultimoConvocatoria] : []);
    } catch (error) {
      // setError("Error al cargar los datos");
    } finally {
      // setLoading(false);
    }
  };
  ////
  const handleSelectItem = (item) => {
    setSelectedItem(item);
  };
  ////Boton Cerrar
  const closeBtn = () => {
    setSelectedItem(null);
  };
  ///Descargar formulario
  const handleDescargarForm = () => {
    const link = document.createElement("a");
    link.href = require("../Admin/documentos/Formularios 2026.xls");
    link.download = "Formularios 2026.xls";
    link.click();
  };
  ////Descargar PDF
  const handleDescargarPdf = async () => {
    var link = document.createElement("a");
    link.setAttribute(
      "href",
      "data:application/pdf;base64," + selectedItem.archivo_com,
    );
    link.setAttribute("download", selectedItem.nom_doc);
    link.click();
  };
  useEffect(() => {
    getConvocatoria();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle} size="lg">
        <ModalHeader
          className="header_mo"
          style={{ position: "relative" }}
          toggle={toggle}
        >
          Requisitos y Formularios
        </ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label>Convocatorias Disponibles </Label>
              <div>
                <Card>
                  <div>
                    {/* Contenido principal */}
                    <div className="p-2">
                      <CardTitle tag="h5">Becas</CardTitle>
                      <CardSubtitle className="text-muted" tag="h6">
                        Becas de educación superior en Universidades y/o
                        Instituciones Públicas
                      </CardSubtitle>
                      <br />
                      <CardText tag="h6">
                        <FaIcons.FaRegCalendarAlt className="text-primary" />
                        <strong> Apertura: </strong>
                        {lista.map((item) => {
                          const fecha = new Date(item.fecha_inicio);
                          return fecha.toLocaleDateString("es-ES", {
                            day: "numeric",
                            month: "long",
                            year: "numeric",
                          });
                        })}
                        <br />
                        <FaIcons.FaRegCalendarTimes className="text-danger" />
                        <strong> Cierre: </strong>
                        {lista.map((item) => {
                          const fecha = new Date(item.fecha_fin);
                          return fecha.toLocaleDateString("es-ES", {
                            day: "numeric",
                            month: "long",
                            year: "numeric",
                          });
                        })}
                      </CardText>
                      <CardText>
                        {lista.map((item) => (
                          <Button
                            color="danger"
                            outline
                            key={item.id_com}
                            onClick={() => handleSelectItem(item)}
                          >
                            <FaIcons.FaRegFilePdf /> Ver y descargar requisitos
                          </Button>
                        ))}
                      </CardText>
                    </div>
                  </div>
                </Card>
              </div>
            </FormGroup>
          </Form>
        </ModalBody>
      </Modal>
      {/* Modal VER CONVOCATORIA */}
      <Modal isOpen={selectedItem !== null} toggle={closeBtn} size="xl">
        {selectedItem && (
          <>
            <ModalHeader className="header_mo" style={{ position: "relative" }}>
              {selectedItem.nom_doc}
            </ModalHeader>
            <ModalBody>
              <Card>
                <CardBody className="p-0">
                  <Row className="justify-content-center">
                    <object
                      data={
                        "data:application/pdf;base64," +
                        selectedItem.archivo_com
                      }
                      type="application/pdf"
                      alt="archivo_per"
                      width="400"
                      height="600"
                    >
                      <p>
                        Tu navegador no puede mostrar este archivo PDF. Puedes
                        descargarlo
                        <a
                          href={
                            "data:application/pdf;base64," +
                            selectedItem.archivo_com
                          }
                          download
                        >
                          aquí
                        </a>
                        .
                      </p>
                    </object>
                  </Row>
                </CardBody>
              </Card>
            </ModalBody>
            <ModalFooter>
              <Button
                style={{ float: "right" }}
                color="primary"
                outline
                onClick={handleDescargarForm}
              >
                <FaIcons.FaRegFileExcel />
                Formulario
              </Button>
              <Button
                style={{ float: "right" }}
                color="primary"
                outline
                onClick={handleDescargarPdf}
              >
                <FaIcons.FaFilePdf />
                Convocatoria
              </Button>
              <Button color="danger" onClick={() => closeBtn()}>
                Cerrar
              </Button>
            </ModalFooter>
          </>
        )}
      </Modal>
    </>
  );
};

export default ModalRequisito;
